import { AgreementByLocationCategory, QnaWriteBottomSheetType } from '@/types/qna';
import { useState } from 'react';

export interface UseQnaWriteBottomSheetGroup {
  agreementData?: AgreementByLocationCategory;
  isApprovedByLocationCategory?: boolean;
  activeBottomSheetType?: QnaWriteBottomSheetType;
  onChangeBottomSheetType: (type?: QnaWriteBottomSheetType) => void;
  isCheckedAgreement: boolean;
  onChangeAgreement: () => void;
  isAiAgreementNeeded: boolean;
}
const useQnaWriteBottomSheetGroup = (): UseQnaWriteBottomSheetGroup => {
  const [activeBottomSheetType, setActiveBottomSheetType] = useState<QnaWriteBottomSheetType>();
  const [isCheckedAgreement, setIsCheckedAgreement] = useState<boolean>(false);

  const onChangeBottomSheetType = (type?: QnaWriteBottomSheetType) => {
    if (!type) {
      return setActiveBottomSheetType(undefined);
    }
    setActiveBottomSheetType(type);
  };

  const onChangeAgreement = () => {
    setIsCheckedAgreement((prev) => !prev);
  };

  return {
    isApprovedByLocationCategory: true,
    activeBottomSheetType,
    onChangeBottomSheetType,
    isCheckedAgreement,
    onChangeAgreement,
    isAiAgreementNeeded: true,
  };
};

export default useQnaWriteBottomSheetGroup;
